import React from 'react';

const OrderList = () => <div>OrderList</div>;

export default OrderList;


// WEBPACK FOOTER //
// ./src/components/OrderList.js